import { render, staticRenderFns } from "./claim-summary-section-item.vue?vue&type=template&id=13b0973e&"
import script from "./claim-summary-section-item.vue?vue&type=script&lang=ts&"
export * from "./claim-summary-section-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports